import { render, staticRenderFns } from "./SidebarMediaDialog.vue?vue&type=template&id=36d8535f&scoped=true"
import script from "./SidebarMediaDialog.vue?vue&type=script&lang=js"
export * from "./SidebarMediaDialog.vue?vue&type=script&lang=js"
import style0 from "./SidebarMediaDialog.vue?vue&type=style&index=0&id=36d8535f&prod&scoped=true&lang=css"
import style1 from "./SidebarMediaDialog.mobile.css?vue&type=style&index=1&id=36d8535f&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d8535f",
  null
  
)

export default component.exports